import { render, staticRenderFns } from "./ContactOutsideOperationBanner.vue?vue&type=template&id=656c4791"
import script from "./ContactOutsideOperationBanner.vue?vue&type=script&lang=js"
export * from "./ContactOutsideOperationBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports